module.exports = __webpack_public_path__ + "static/media/aveena_dange.aedb52cf.png";